import { API_ROUTE } from "../constants/workerConstants";
import AxiosInstance from "./http.handlers";

export const GetInvoices = async (headers) => {
  return await AxiosInstance.get(`${API_ROUTE.INVOICE_RULES.CRUD_INVOICE}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const CreateInvoice = async (payload, headers) => {
  return await AxiosInstance.post(
    `${API_ROUTE.INVOICE_RULES.CRUD_INVOICE}`,
    payload,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};

export const GetInvoice = async (id, headers) => {
  return await AxiosInstance.get(
    `${API_ROUTE.INVOICE_RULES.CRUD_INVOICE}/${id}`,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};

export const updateInvoice = async (id, payload, headers) => {
  return await AxiosInstance.put(
    `${API_ROUTE.INVOICE_RULES.CRUD_INVOICE}/${id}`,
    payload,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};
